import { application } from 'controllers/application'

import ChangeCalculatorController from 'controllers/change_calculator_controller'
import FormInputsGroupValidator from 'controllers/form_inputs_group_validator_controller'
import PaymentTypeSelectorController from 'controllers/payment_type_selector_controller'
import ConektaPaymentController from 'controllers/conekta_payment_controller'
import OrderConfirmationController from 'controllers/order_confirmation_controller'
import PaypalCheckoutController from 'controllers/paypal_checkout_controller'
import SectionScrollerController from 'controllers/section_scroller_controller'
import SubmitActionsSnackbarController from 'controllers/submit_actions_snackbar_controller'
import ToggleClassOnViewportIntersectionController from 'controllers/toggle_class_on_viewport_intersection_controller'

application.register('change-calculator', ChangeCalculatorController)
application.register('form-inputs-group-validator', FormInputsGroupValidator)
application.register('payment-type-selector', PaymentTypeSelectorController)
application.register('conekta-payment', ConektaPaymentController)
application.register('order-confirmation', OrderConfirmationController)
application.register('paypal-checkout', PaypalCheckoutController)
application.register('section-scroller', SectionScrollerController)
application.register('submit-actions-snackbar', SubmitActionsSnackbarController)
application.register('toggle-class-on-viewport-intersection', ToggleClassOnViewportIntersectionController)
